// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "public/css/" + chunkId + "." + "0c76fd67dd9147a3a4a8" + ".css";
};